module.exports = "<app-widgets-searchbox config=$ctrl.bookSearchConfig placeholder=\"{{ 'Search' | translate }}\" value=$ctrl.book> </app-widgets-searchbox> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/route/edit/book/partial.html
// module id = 464
// module chunks = 0